import { useSpaceIdentifiers } from './useSpaceIdentifiers';

export const useSpaceId = (spaceKey?: string): string | undefined => {
	const { spaceId } = useSpaceIdentifiers(spaceKey);
	return spaceId;
};
